// src/components/AdminSettings/modals/RewardModal.tsx
import React from 'react';
import { IonItem, IonLabel, IonRange } from '@ionic/react';
import { Modal, ModalSection } from '../../ui/Modal';
import { TextInput } from '../../ui/TextInput';
import { IconPicker, type IconValue } from '../../ui/IconPicker';
import type { RewardModalProps } from '../types';

export const RewardModal: React.FC<RewardModalProps> = ({
  isOpen,
  onClose,
  editingReward,
  form,
  onFormChange,
  onSave,
  onDelete,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      header={{ title: editingReward ? 'Edit Reward' : 'Add Reward' }}
      footer={{
        primaryAction: {
          label: editingReward ? 'Save' : 'Add Reward',
          onClick: onSave,
          disabled: !form.name,
        },
        secondaryAction: { label: 'Cancel', onClick: onClose },
        ...(editingReward && {
          tertiaryAction: {
            label: 'Delete',
            onClick: onDelete,
            variant: 'danger' as const,
          },
        }),
      }}
    >
      <ModalSection spacing="normal">
        <TextInput
          label="Name"
          value={form.name}
          onChange={(v) => onFormChange({ ...form, name: v })}
          placeholder="e.g., 30 Min Screen Time"
          variant="default"
        />
        <div style={{ marginTop: 16 }}>
          <label style={{
            display: 'block',
            fontFamily: 'var(--kff-data-font)',
            fontSize: 13,
            fontWeight: 500,
            color: 'var(--ion-color-medium)',
            marginBottom: 8,
          }}>
            Icon
          </label>
          <IconPicker
            value={form.icon ? { type: 'emoji', name: form.icon } : null}
            onChange={(icon: IconValue) => onFormChange({ ...form, icon: icon.name })}
            defaultTab="emoji"
            tabs={['emoji', 'ionic', 'mdi', 'lucide']}
            iconSize={28}
            maxHeight={200}
          />
        </div>
        <IonItem style={{ marginTop: 16, '--background': 'transparent' }}>
          <IonLabel position="stacked">Points Cost: {form.points_cost}</IonLabel>
          <IonRange
            min={1}
            max={50}
            value={form.points_cost}
            onIonChange={e => onFormChange({ ...form, points_cost: e.detail.value as number })}
          />
        </IonItem>
      </ModalSection>
    </Modal>
  );
};

export default RewardModal;
